import React from 'react';
import { ShoppingCartItemsProps } from '../interfaces';
import ShoppingCartItem from '../shoppingCartItem';

const ShoppingCartItems: React.FC<ShoppingCartItemsProps> = ({
  cartItems,
  sizeErrors,
}) => (
  <>
    {cartItems.map((item) => (
      <ShoppingCartItem
        key={item.id}
        item={item}
        isSizeError={sizeErrors.includes(item.id)}
      />
    ))}
  </>
);

export default React.memo(ShoppingCartItems);
